import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=2a2b5d55&scoped=true&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=2a2b5d55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2b5d55",
  null
  
)

export default component.exports